import axios from 'axios';
import router from '../../router';
import { apiBaseUrl } from "@/environment/environment";

const httpClient = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

export function setHeader(header) {
  if (!httpClient.defaults.headers) {
    httpClient.defaults.headers = {};
  }
  httpClient.defaults.headers[header.key] = header.value;
}

export function setResponseType(responseType) {
  httpClient.defaults.responseType = responseType;
}

export function removeResponseType() {
  delete httpClient.defaults.responseType;
}

const authInterceptor = (config) => {
  const token = localStorage.getItem("token");

  if (!config.headers) {
    config.headers = {};
  }

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
};

// Interceptor de logs
const loggerInterceptor = (config) => {
  // console.log("Request:", config);
  return config;
};

// Agregar interceptores
httpClient.interceptors.request.use(authInterceptor);
httpClient.interceptors.request.use(loggerInterceptor);

// Interceptor de respuesta
httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error("API Error:", error);

    if (error?.response?.status) {
      switch (error.response.status) {
        case 400:
          console.error('Solicitud incorrecta.');
          break;

        case 401:
          console.error('La sesión ha expirado.');
          localStorage.removeItem("token");
          router.replace({ path: "/login" });
          break;

        case 403:
          console.error('No está autorizado.');
          break;

        case 404:
          console.error('La página no existe.');
          break;

        case 502:
          console.error('Error en el servidor.');
          setTimeout(() => {
            router.replace({ path: "/login" });
          }, 1000);
          break;

        default:
          console.error('Error desconocido.');
      }
      return Promise.reject(error.response);
    }

    return Promise.reject(error);
  }
);

export { httpClient };

